export const en = {
    title: `Resend Confirmation Email`,
    description: `Your account is not confirmed.`,
    lastSentAt: `Last confirmation email sent at {date}`,
    wait: `Please wait {minutes} minutes before resending.`,
    resendButton: `Resend email`,
    emailResent: `Confirmation email has been resent`,
    success: `Confirmation email sent.`,
    failure: `Failed to resend confirmation email.`,
    progress: `Resending confirmation email...`,
};
//# sourceMappingURL=en.js.map